import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { onboardingSelector } from '../../../reducers/onboarding';
import { apiRequest } from '../../../APIClient';

// on mount, fetch site section once if it hasn't been fetched before
export const useFetchSiteSection = () => {
  const hasFetched = useSelector(onboardingSelector.hasFetchedSiteSection);

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (!hasFetched) {
      dispatch(apiRequest.getOBSites());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
};
